import { forwardRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { journeyUrl } from '@/components/redesign/journeyNavigation';
const JourneyLink = forwardRef(function JourneyLink({ to, onClick, state, replace, ...props }, ref) {
  const navigate = useNavigate();
  const target = journeyUrl(to);
  const from = window.location.pathname + window.location.search + window.location.hash;
  const nextState = { ...state, journeyFrom: from };
  return <Link {...props} ref={ref} to={target} state={nextState} replace={replace} onClick={event => {
    onClick?.(event);
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey || props.target === '_blank') return;
    const latest = journeyUrl(to);
    if (latest !== target) {
      event.preventDefault();
      navigate(latest, { replace, state: { ...state, journeyFrom: window.location.pathname + window.location.search + window.location.hash } });
    }
  }} />;
});
export default JourneyLink;